import { useTranslation } from "react-i18next";

export default function TopBar() {
  const { t } = useTranslation("home");

  return (
    <div className="bg-brand-text text-white text-xs tracking-wider w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10 flex justify-between items-center h-10">
        <div className="font-geist-mono uppercase flex items-center gap-1.5">
          <i className="ri-phone-line w-4 h-4 flex items-center justify-center text-[11px]"></i>
          <span>{t("topBar.phone")}</span>
        </div>
        <a
          href="mailto:info@ramen-repair-eindhoven.nl"
          className="font-geist-mono uppercase flex items-center gap-1.5 hover:text-brand-yellow transition-colors"
        >
          <i className="ri-mail-line w-4 h-4 flex items-center justify-center text-[11px]"></i>
          <span>{t("topBar.email")}</span>
        </a>
      </div>
    </div>
  );
}